<script>
import Tabela from "@components/TabelaDePara.vue";
import api from "@services/api";
import Select2 from "v-select2-component";

export default {
  components: { Tabela, Select2 },
  data() {
    return {
      categoriaDeParaList: [],
      categoriaDeparaListApi: [],
      selected: -1,
      filter: null,
      showModalCadastro: false,
      categoriaDeParaId: null,
      paraDefault: "",
      todosDe: false,
      busca: "",
      buscaTmp: "",
      hasAlert: false,
      temDominio: false
    };
  },
  watch: {
    categoriaDeParaId: function(value) {
      this.temDominio = this.categoriaDeparaListApi.filter(
        x => x.id == value
      )[0].existeDominio;
    }
  },
  methods: {
    changeShowModalCadastro(value) {
      this.showModalCadastro = value;
    },
    getCategoriaDeParaList() {
      api
        .get(`crud/CategoriaDePara`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => {
          this.categoriaDeparaListApi = response.data["data"];
          this.categoriaDeParaList = [];
          this.categoriaDeparaListApi.forEach(e => {
            this.categoriaDeParaList.push({
              id: e.id,
              text: e.descricao,
              default: e.paraDefault
            });
          });

          if (this.categoriaDeParaList.length > 0) {
            if (this.selected == -1) {
              this.selected = this.categoriaDeParaList[0].id;
              this.filtrarCategoria();
            }
            this.paraDefault = this.categoriaDeParaList[0].default;
          }
        });
    },
    filtrarCategoria() {
      this.limparBusca();
      this.categoriaDeParaId = this.selected;
      this.paraDefault = this.categoriaDeParaList.find(
        el => el.id == parseInt(this.selected)
      ).default;
      this.filter = "CategoriaDeParaId eq " + this.selected + " AND ";
    },
    atualizarParaDefault() {
      let formData = new FormData();
      formData.append("CategoriaDeParaId", this.categoriaDeParaId);
      formData.append("paraDefault", this.paraDefault);
      api.post(`crud/DePara/UpdateParaDefault`, formData).then(response => {
        if (response.data["status"].toLowerCase() == "success") {
          this.getCategoriaDeParaList();
          this.hasAlert = true;
        }
      });
    },
    buscar() {
      this.busca = this.buscaTmp;
    },
    fecharAlert() {
      this.hasAlert = false;
    },
    limparBusca() {
      this.busca = "";
      this.buscaTmp = "";
    }
  },
  created() {
    this.getCategoriaDeParaList();
  }
};
</script>

<template>
  <div>
    <b-alert v-model="hasAlert" variant="success" dismissible>
      Valor padrão atualizado com sucesso!
    </b-alert>

    <div class="row">
      <div class="col-md-4">
        <b-form-group
          id="input-group-1"
          label="Categoria"
          label-for="categoria"
        >
          <div>
            <Select2
              v-model="selected"
              :options="categoriaDeParaList"
              :settings="{ tags: false }"
              v-on:change="filtrarCategoria()"
            />
          </div>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group
          id="input-group-1"
          label="Valor padrão"
          label-for="Default"
        >
          <b-form-row>
            <b-col>
              <b-form-input v-model="paraDefault" type="text"></b-form-input>
            </b-col>

            <b-col>
              <b-button
                type="submit"
                variant="primary"
                v-on:click="atualizarParaDefault()"
                ><i class="fe-edit" />
              </b-button>
            </b-col>

            <b-col>
              <b-form-checkbox v-show="this.temDominio" v-model="todosDe"
                >Exibir todos</b-form-checkbox
              >
            </b-col>
          </b-form-row>
        </b-form-group>
      </div>

      <!-- div row -->
    </div>

    <div class="row">
      <div class="col-md-8 ">
        <b-form-group id="input-group-1" label="Buscar" label-for="Buscar">
          <b-form-row>
            <b-col>
              <b-form-input v-model="buscaTmp" type="text"></b-form-input>
            </b-col>
            <b-col>
              <b-button type="submit" variant="primary" v-on:click="buscar()"
                ><i class="fe-search"
              /></b-button>
            </b-col>
          </b-form-row>
        </b-form-group>
      </div>
      <div
        class="col-md-4 mt-3"
        style="{ margin: 'auto auto auto auto' };text-align: right"
      >
        <b-button
          type="submit"
          variant="primary"
          v-on:click="showModalCadastro = true"
          >Novo</b-button
        >
      </div>
    </div>
    <Tabela
      :filter="filter"
      :showModalInsert="showModalCadastro"
      :CategoriaDeParaId="parseInt(selected)"
      :todosde="todosDe"
      :busca="busca"
      @update-showModalCadastro="changeShowModalCadastro"
    />
    <!-- div geral -->
  </div>
</template>
